module.exports = __webpack_public_path__ + "img/givenchy-ange-noir.7f2a9e74.jpg";